// Generate a hash code from a given string
export const hash = (string: string): number => {
  let hashCode: number = 0
  for (let index = 0; index < string.length; index++) {
    // eslint-disable-next-line no-bitwise
    hashCode = (Math.imul(31, hashCode) + string.charCodeAt(index)) | 0
  }
  return hashCode
}
